import {
  EditOutlined,
  LockOutlined,
  PauseOutlined,
  SyncOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";

export type IntegrationProductAction =
  | "lock"
  | "unlock"
  | "editIntegrationSync"
  | "pauseIntegration"
  | "sync";

export function isIntegrationProductAction(key: string): key is IntegrationProductAction {
  return (
    key === "lock" ||
    key === "unlock" ||
    key === "editIntegrationSync" ||
    key === "pauseIntegration" ||
    key === "sync"
  );
}

/** Same entries for rad-meny och massåtgärder (integration / Northmill). */
export const integrationProductActionMenuItems: MenuProps["items"] = [
  { key: "editIntegrationSync", label: "Redigera artiklar", icon: <EditOutlined /> },
  { key: "lock", label: "Lås artikel", icon: <LockOutlined /> },
  { key: "unlock", label: "Lås upp artikel", icon: <UnlockOutlined /> },
  { key: "pauseIntegration", label: "Pausa", icon: <PauseOutlined /> },
  { key: "sync", label: "Synkronisera", icon: <SyncOutlined /> },
];
